/* global SideDrawer */




if (!customElements.get('quick-add-drawer')) {
  class QuickAddDrawer extends SideDrawer {
    constructor() {
      super();
      this.content = this.querySelector('.js-product-details');
      this.footer = this.querySelector('.drawer__footer');
      this.form = this.querySelector('product-form');
      this.notification = this.querySelector('.js-added-to-cart');
      this.backBtn = this.querySelector('.drawer__back-btn');
      this.openCartDrawerLinks = this.querySelectorAll('.js-open-cart-drawer');
      this.cartDrawer = document.querySelector('cart-drawer');
      this.fetch = null;
      this.fetchedUrls = [];
      this.quickAddButtonMouseEnterHandler = this.handleQuickAddButtonMouseEnter.bind(this);
      this.documentClickHandler = this.handleDocumentClick.bind(this);

      document.addEventListener('click', this.documentClickHandler);
      this.addEventListener('on:variant:change', this.handleVariantChange.bind(this));

      this.openCartDrawerLinks.forEach((link) => {
        link.addEventListener('click', this.handleOpenCartClick.bind(this));
      });

      if (theme.device.hasHover && theme.mediaMatches.md) {
        document.querySelectorAll('.js-quick-add').forEach((button) => {
          this.bindQuickAddButtonMouseEnter(button);
        });

        if ('MutationObserver' in window) {
          this.observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
              // Add event listener to new buttons
              mutation.addedNodes.forEach((node) => {
                if (node.nodeType === Node.ELEMENT_NODE) {
                  node.querySelectorAll('.js-quick-add').forEach((button) => {
                    this.bindQuickAddButtonMouseEnter(button);
                  });
                }
              });

              // Remove event listener from removed buttons
              mutation.removedNodes.forEach((node) => {
                if (node.nodeType === Node.ELEMENT_NODE) {
                  node.querySelectorAll('.js-quick-add').forEach((button) => {
                    button.removeEventListener('mouseenter', this.quickAddButtonMouseEnterHandler);
                  });
                }
              });
            });
          });

          // Start observing changes to the DOM
          this.observer.observe(document.body, { childList: true, subtree: true });
        }
      }
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.documentClickHandler);
      document.querySelectorAll('.js-quick-add').forEach((button) => {
        button.removeEventListener('mouseenter', this.quickAddButtonMouseEnterHandler);
      });
      if (this.observer) this.observer.disconnect();
    }

    /**
     * Bind a mouseenter event to a given quick add button if it's not already bound
     * @param {Element} button - The button element to bind the mouseenter event to.
     */
    bindQuickAddButtonMouseEnter(button) {
      if (!button.dataset.quickAddListenerAdded) {
        button.dataset.quickAddListenerAdded = 'true';
        button.addEventListener('mouseenter', this.quickAddButtonMouseEnterHandler);
      }
    }

    /**
     * Start the fetch on hover of a quick add button for perceived performance gains
     * @param {object} evt - Event object.
     */
    handleQuickAddButtonMouseEnter(evt) {
      if (!this.fetchedUrls.includes(evt.target.dataset.productUrl)) {
        this.fetch = {
          url: evt.target.dataset.productUrl,
          promise: fetch(evt.target.dataset.productUrl)
        };
        this.fetchedUrls.push(evt.target.dataset.productUrl);
      }
    }

    /**
     * Handles 'click' events on success notification's 'View cart' link
     * @param {object} evt - Event object.
     */
    handleOpenCartClick(evt) {
      // Open the cart drawer if available on the page
      if (this.cartDrawer) {
        evt.preventDefault();
        this.cartDrawer.open();
      } else if (window.location.pathname === theme.routes.cart) {
        evt.preventDefault();
        this.close();
      }
    }

    /**
     * Handles 'click' events on the document.
     * @param {object} evt - Event object.
     */
handleDocumentClick(evt) {
   
  if (!evt.target.matches('.js-quick-add')) return;

  document.body.style.overflow = 'hidden';

  if (this.cartDrawer && this.cartDrawer.ariaHidden === 'false') {
    const overlay = document.querySelector('.js-overlay.is-visible');
    if (overlay) overlay.style.transitionDelay = '200ms';
    this.cartDrawer.close();

    setTimeout(() => {
      this.backBtn.hidden = false;
      this.open(evt.target);

      if (overlay) overlay.style.transitionDelay = '';

    }, 200);
  } else {
    this.open(evt.target);

}

}


    /**
     * Handles 'on:variant:change' events on the Quick Add drawer.
     * @param {object} evt - Event object.
     */
    handleVariantChange(evt) {
      let url = this.productUrl;

      if (evt.detail.variant) {
        const separator = this.productUrl.split('?').length > 1 ? '&' : '?';
        url += `${separator}variant=${evt.detail.variant.id}`;
      }

      this.querySelectorAll('.js-prod-link').forEach((link) => {
        link.href = url;
      });
    }

    /**
     * Opens the drawer and fetches the product details.
     * @param {Element} opener - Element that triggered opening of the drawer.
     */
    async open(opener) {
      opener.setAttribute('aria-disabled', 'true');

      if (this.notification) this.notification.hidden = true;

      // If it's the same product as previously shown, there's no need to re-fetch the details.
      if (this.productUrl && this.productUrl === opener.dataset.productUrl) {
        super.open(opener);
        opener.removeAttribute('aria-disabled');
        return;
      }

      this.productUrl = opener.dataset.productUrl;
      this.content.innerHTML = '';
      this.classList.add('is-loading');
      this.content.classList.add('drawer__content--out');
      this.footer.classList.add('drawer__footer--out');

      super.open(opener);

      if (!this.fetch || this.fetch.url !== opener.dataset.productUrl) {
        this.fetch = {
          url: opener.dataset.productUrl,
          promise: fetch(opener.dataset.productUrl)
        };
      }

      const response = await this.fetch.promise;
      if (response.ok) {
        const tmpl = document.createElement('template');
        tmpl.innerHTML = await response.text();
        this.productEl = tmpl.content.querySelector('.cc-main-product .js-product');
        this.renderProduct(opener);
      }

      this.fetch = null;

      opener.removeAttribute('aria-disabled');
    }

    /**
     * Closes the cart drawer.
     */
    close() {
      super.close(() => {
        this.backBtn.hidden = true;
        document.body.style.overflow = '';
      });
    }

    /**
     * Renders the product details.
     * @param {Element} opener - Element that triggered opening of the drawer.
     */
    renderProduct(opener) {
      // Replace instances of section id to prevent duplicates on the product page.
      const sectionId = this.productEl.dataset.section;
      this.productEl.innerHTML = this.productEl.innerHTML.replaceAll(sectionId, 'quickadd');

      // Prevent variant picker from updating the URL on change.
      const variantPicker = this.productEl.querySelector('variant-picker');
      if (variantPicker) {
        variantPicker.dataset.updateUrl = 'false';
        this.selectFirstVariant = variantPicker.dataset.selectFirstVariant === 'true';
      }

      // Remove size chart modal and link (if they exist).
      const sizeChartModal = this.productEl.querySelector('[data-modal="size-chart"]');
      if (sizeChartModal) {
        sizeChartModal.remove();
      }

      this.updateContent();
      this.updateForm();

      // Update the product media.
      const activeMedia = this.productEl.querySelector('.media-viewer__item.is-current-variant');
      if (activeMedia) this.updateMedia(activeMedia.dataset.mediaId);

      if (opener.dataset.selectedColor && this.selectFirstVariant) {
        // Timeout to allow the VariantPicker to initialize
        setTimeout(this.setActiveVariant.bind(this, opener), 10);
      }
    }

    /**
     * Set color variant to match the one selected in the card.
     * @param {Element} opener - Element that triggered opening of the drawer.
     */
    setActiveVariant(opener) {
      const colorOptionBox = this.querySelector(`.opt-btn[value="${opener.dataset.selectedColor}"]`);
      if (colorOptionBox) {
        this.querySelector(`.opt-btn[value="${opener.dataset.selectedColor}"]`)
          .click();
      } else {
        const colorOptionDropdown = this.querySelector(
          `.custom-select__option[data-value="${opener.dataset.selectedColor}"]`
        );
        if (colorOptionDropdown) {
          const customSelect = colorOptionDropdown.closest('custom-select');
          customSelect.selectOption(colorOptionDropdown);
        }
      }
    }

    /**
     * Updates the product media.
     * @param {string} mediaId - Id of the media item to show.
     */
    updateMedia(mediaId) {
      const img = this.productEl.querySelector(`[data-media-id="${mediaId}"] img`);
      if (!img) return;

      const src = img.src ? img.src.split('&width=')[0] : img.dataset.src.split('&width=')[0];
      const container = this.querySelector('.quick-add-info__media');
      const width = container.offsetWidth;
      const aspectRatio = img.width / img.height;

      container.innerHTML = `
        <img src="${src}&width=${width}" srcset="${src}&width=${width}, ${src}&width=${width * 2} 2x" width="${width * 2}" height="${(width * 2) / aspectRatio}" alt="${img.alt}">
      `;
    }

    /**
     * Builds the markup for the drawer content element.
     */
    updateContent() {

     

      let weightElem = this.getElementHtml('.product-info__weight');
      if (weightElem && weightElem.length > 0) {
        weightElem = `<div class="product-info__weight text-sm mt-2">${weightElem}</div>`;
      }

      this.content.innerHTML = `
        <div class="quick-add-info">

          ${this.getElementHtml('.product_media')}
          <div class="product_info__details">

              <div class="product_info">
                <a class="js-prod-link" href="${this.productUrl}">
                  ${this.getElementHtml('.product-title')}
                </a>
               <div class="product_description">
                 ${this.getElementHtml('.product-description')}
               </div>
            </div>  

             <div class="product_info">
                <div class="product_price">
                  ${this.getElementHtml('.product-price')}
               </div>
               <div class="coupon_block">
                 ${this.getElementHtml('.coupon_block')}
               </div>
             </div>

             <div class="product_info">
                <div class="product-options">
                  ${this.getElementHtml('.product-options', '.custom-option:not(.quick-add-hidden)')}
                </div>
             </div>
             <div class="product-signup">
               ${this.getElementHtml('.product-signup')}
             </div>
             <div class="similar_products">
              ${this.getElementHtml('.similar_products')}
             </div>

             
             <div class="product_info">
                <div class="shipping_block">
                  ${this.getElementHtml('.shipping_block')}
                </div>
                <div class="page_popup_btn" data-popup=".page_id_701012115605">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"> <path d="M16 2.00024V6.00024M8 2.00024V6.00024" stroke="#1D1D1D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M13 4.00024H11C7.22876 4.00024 5.34315 4.00024 4.17157 5.17181C3 6.34339 3 8.229 3 12.0002V14.0002C3 17.7714 3 19.6571 4.17157 20.8286C5.34315 22.0002 7.22876 22.0002 11 22.0002H13C16.7712 22.0002 18.6569 22.0002 19.8284 20.8286C21 19.6571 21 17.7714 21 14.0002V12.0002C21 8.229 21 6.34339 19.8284 5.17181C18.6569 4.00024 16.7712 4.00024 13 4.00024Z" stroke="#1D1D1D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M3 10.0002H21" stroke="#1D1D1D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M11.9955 14.0002H12.0045M11.9955 18.0002H12.0045M15.991 14.0002H16M8 14.0002H8.00897M8 18.0002H8.00897" stroke="#1D1D1D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/> </svg>
                  <p>30-Day Price-Match</p>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"> <g clip-path="url(#clip0_3414_37756)"> <path d="M7.70846 8.16772L12.2935 12.7527L16.8785 8.16772L18.2935 9.58272L12.2935 15.5827L6.29346 9.58272L7.70846 8.16772Z" fill="#1D1D1D"/> </g> <defs> <clipPath id="clip0_3414_37756"> <rect width="24" height="24" fill="white" transform="translate(0 0.000244141)"/> </clipPath> </defs> </svg>
                </div>
                <div class="page_popup_btn" data-popup=".page_id_701016014997">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"> <path d="M15.5259 15.9774H18.7652C20.0444 15.9558 21.9986 16.6291 21.9986 19.0573C21.9986 21.5768 19.5871 21.9992 18.7652 21.9992C17.9433 21.9992 10.1816 21.9992 7.94429 21.9992C5.4383 21.9992 1.99999 21.4916 2 17.1683V8.00305H21.9986V12.52M15.5259 15.9774C15.5313 15.7635 15.6223 15.5514 15.7991 15.3973L17.5009 13.977M15.5259 15.9774C15.5202 16.2056 15.612 16.4359 15.8013 16.5998L17.5009 17.9834" stroke="#1D1D1D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M2.00391 7.99144L2.92544 5.69052C3.67321 3.90235 4.04711 3.00827 4.80496 2.50487C5.56282 2.00146 6.53494 2.00146 8.47917 2.00146H15.4985C17.4427 2.00146 18.4148 2.00146 19.1727 2.50487C19.9306 3.00827 20.3044 3.90235 21.0522 5.69052L21.9981 7.995" stroke="#1D1D1D" stroke-width="1.5" stroke-linecap="round"/> <path d="M11.9648 8.00122V2.00122" stroke="#1D1D1D" stroke-width="1.5" stroke-linecap="round"/> <path d="M9.96094 12.0012H13.9609" stroke="#1D1D1D" stroke-width="1.5" stroke-linecap="round"/> </svg>
                  <p>30-Day Returns</p>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"> <g clip-path="url(#clip0_3414_37756)"> <path d="M7.70846 8.16772L12.2935 12.7527L16.8785 8.16772L18.2935 9.58272L12.2935 15.5827L6.29346 9.58272L7.70846 8.16772Z" fill="#1D1D1D"/> </g> <defs> <clipPath id="clip0_3414_37756"> <rect width="24" height="24" fill="white" transform="translate(0 0.000244141)"/> </clipPath> </defs> </svg>
                </div>
                <div class="page_popup_btn" data-popup=".page_id_701016277141">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"> <path d="M22 12.0002C22 6.47739 17.5228 2.00024 12 2.00024C6.47715 2.00024 2 6.47739 2 12.0002C2 17.523 6.47715 22.0002 12 22.0002C17.5228 22.0002 22 17.523 22 12.0002Z" stroke="#1D1D1D" stroke-width="1.5"/> <path d="M12.8638 7.72234L13.7437 9.49669C13.8637 9.74369 14.1837 9.9806 14.4536 10.0259L16.0485 10.2931C17.0684 10.4645 17.3083 11.2105 16.5734 11.9464L15.3335 13.1966C15.1236 13.4083 15.0086 13.8166 15.0736 14.1089L15.4285 15.6564C15.7085 16.8814 15.0636 17.3552 13.9887 16.715L12.4939 15.8228C12.2239 15.6615 11.7789 15.6615 11.504 15.8228L10.0091 16.715C8.93925 17.3552 8.28932 16.8763 8.56929 15.6564L8.92425 14.1089C8.98925 13.8166 8.87426 13.4083 8.66428 13.1966L7.42442 11.9464C6.6945 11.2105 6.92947 10.4645 7.94936 10.2931L9.54419 10.0259C9.80916 9.9806 10.1291 9.74369 10.2491 9.49669L11.129 7.72234C11.609 6.75955 12.3889 6.75955 12.8638 7.72234Z" stroke="#1D1D1D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>
                 <p>2-Year Warranty</p>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"> <g clip-path="url(#clip0_3414_37756)"> <path d="M7.70846 8.16772L12.2935 12.7527L16.8785 8.16772L18.2935 9.58272L12.2935 15.5827L6.29346 9.58272L7.70846 8.16772Z" fill="#1D1D1D"/> </g> <defs> <clipPath id="clip0_3414_37756"> <rect width="24" height="24" fill="white" transform="translate(0 0.000244141)"/> </clipPath> </defs> </svg>
                </div>

             </div>

              <div class="main_accordion_list">
              <div class="specification accordion_list">
               ${this.getElementHtml('.specification.quick_add_data')}
              </div>
              <div class="accordion_list">
               ${this.getElementHtml('.accordion_list_HGCqYr.quick_add_data')}
              </div>
             </div>

              <a href="${this.productUrl}" class="full_details_btn btn">
               Full Details
              </a>

          </div>
        
      `;

      this.classList.remove('is-loading');
      this.content.classList.remove('drawer__content--out');
    }

    /**
     * Updates the Quick Add drawer form (buy buttons).
     */
    updateForm() {
      const productForm = this.productEl.querySelector('product-form');
      this.footer.classList.remove('quick-add__footer-message');

      if (productForm) {
        this.form.innerHTML = productForm.innerHTML;
        this.form.init();

        if (Shopify && Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
            initQuickAddSwiper();
        }
      } else {
        const signUpForm = this.productEl.querySelector('.product-signup');
        if (signUpForm) {
          this.form.innerHTML = signUpForm.innerHTML;
        } else {
          this.footer.classList.add('quick-add__footer-message');
          this.form.innerHTML = `
            <div class="alert quick-add__alert bg-info-bg text-info-text">
              <div class="flex">
                <div>
                  <svg class="icon icon--price_tag" width="32" height="32" viewBox="0 0 16 16" aria-hidden="true" focusable="false" role="presentation">
                    <path fill="currentColor" d="M7.59 1.34a1 1 0 01.7-.29h5.66a1 1 0 011 1v5.66a1 1 0 01-.3.7L7.6 15.5a1 1 0 01-1.42 0L.52 9.83a1 1 0 010-1.42l7.07-7.07zm6.36 6.37l-7.07 7.07-5.66-5.66L8.3 2.05h5.66v5.66z" fill-rule="evenodd"/>
                    <path fill="currentColor" d="M9.7 6.3a1 1 0 101.42-1.42 1 1 0 00-1.41 1.41zM9 7a2 2 0 102.83-2.83A2 2 0 009 7z" fill-rule="evenodd"/>
                  </svg>
                </div>
                <div>
                  <p class="text-h6 font-bold mb-2">${theme.strings.awaitingSale}</p>
                  <a class="link js-prod-link" href="${this.productUrl}">${theme.strings.viewDetails}</a>
                </div>
              </div>
            </div>`;
        }
      }

      this.footer.classList.remove('drawer__footer--out');
    }

    /**
     * Gets the innerHTML of elements within the product element.
     * @param {string} selector - CSS selector for the element.
     * @param {...*} additionalSelectors - Additional CSS selectors for elements.
     * @returns {?string}
     */
    getElementHtml(selector, ...additionalSelectors) {
      const selectors = [selector].concat(additionalSelectors);
      let html = '';
      selectors.forEach((sel) => {
        const els = this.productEl.querySelectorAll(sel);
        Array.from(els).forEach((el) => {
          html += el.innerHTML;
        });
      });
      return html;
    }

    /**
     * Shows an "Added to cart" message in the drawer.
     */
    addedToCart() {
      if (this.notification) {
        setTimeout(() => {
          this.notification.hidden = false;
        }, 300);

        setTimeout(() => {
          this.notification.hidden = true;
        }, this.notification.dataset.visibleFor);
      }
    }
  }

  customElements.define('quick-add-drawer', QuickAddDrawer);
}



function initQuickAddSwiper() {


const swiperWrapperadd = document.getElementById("swiper_wrapperquickadd");
  const tabContaineradd = document.getElementById("tabs_containerquickadd");

  if (!swiperWrapperadd || !tabContaineradd) return;

  const slides = swiperWrapperadd.querySelectorAll(".quickadd .swiper-slide.product_img");

  const indexMap = {};
  const tabNamesMap = {
    scenes: "Scenes",
    video: "Video",
    details: "Details",
    specs: "Specs",
    comments: "Comments",
  };

  slides.forEach((slide, i) => {
    const tab = slide.dataset.tab;
    if (!indexMap[tab]) {
      indexMap[tab] = { start: i, length: 0 };
    }
    indexMap[tab].length += 1;
  });

  function generateTabs() {

    tabContaineradd.innerHTML = "";
    for (const tab in indexMap) {
      const btn = document.createElement("div");
      btn.classList.add("tab-btn");
      btn.dataset.tab = tab;
      btn.innerHTML = `${tabNamesMap[tab]} <span class="tab-counter" id="counter-${tab}">(0 / ${indexMap[tab].length})</span>`;
      tabContaineradd.appendChild(btn);
    }
    if (tabContaineradd.children.length) {
      tabContaineradd.children[0].classList.add("active");
    }
  }

  function updateUI(activeIndex) {
    let currentTab = null;
    for (const tab in indexMap) {
      const start = indexMap[tab].start;
      const end = start + indexMap[tab].length - 1;
      if (activeIndex >= start && activeIndex <= end) {
        currentTab = tab;
        break;
      }
    }

    document.querySelectorAll(".tab-btn").forEach((btn) => {
      btn.classList.toggle("active", btn.dataset.tab === currentTab);
    });

    if (currentTab) {
      const subIndex = activeIndex - indexMap[currentTab].start + 1;
      const total = indexMap[currentTab].length;
      const counter = document.getElementById(`counter-${currentTab}`);
      if (counter) {
        counter.textContent = `(${subIndex} / ${total})`;
      }
    }
  }

  const thumbsSwiper = new Swiper(".product_swiper_thumbsquickadd", {
    slidesPerView: "auto",
    spaceBetween: 20,
    watchSlidesProgress: true,
    watchSlidesVisibility: true,
    slideToClickedSlide: true,
    breakpoints: {
      768: { direction: "vertical" },
    },
  });

  const swiper = new Swiper(".cus_product_swiperquickadd", {
    loop: false,
    navigation: {
      nextEl: ".swiper-button-nextquickadd",
      prevEl: ".swiper-button-prevquickadd",
    },
    thumbs: {
      swiper: thumbsSwiper,
    },
    on: {
      slideChange: () => {
        updateUI(swiper.realIndex);
      },
    },
  });

  tabContaineradd.addEventListener("click", (e) => {
    const btn = e.target.closest(".tab-btn");
    if (btn) {
      const tab = btn.dataset.tab;
      const index = indexMap[tab].start;
      swiper.slideTo(index);
    }
  });

  generateTabs();
  updateUI(0);



  
    const accordions = document.querySelectorAll('.accordionquickadd');

    accordions.forEach((accordion) => {
      const panel = accordion.nextElementSibling;

      accordion.addEventListener('click', () => {
        accordion.classList.toggle('active');
        if (panel) {
          if (panel.style.maxHeight && panel.style.maxHeight !== '0px') {
            panel.style.maxHeight = '0';
          } else {
            panel.style.maxHeight = panel.scrollHeight + 'px';
          }
        }
      });
    });


    const openBtn = document.getElementById('open-coupon-popup-btnquickadd');
    const closeBtn = document.getElementById('coupon-popup-close');
    const popup = document.getElementById('coupon-popup-overlay');

    if (openBtn) {
      openBtn.addEventListener('click', () => {
        popup.style.display = 'flex';
        document.body.style.overflow = 'hidden'; // Disable scrolling
      });
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        popup.style.display = 'none';
         document.body.style.overflow = 'hidden'; // Disable scrolling
      });
    }



    document.querySelectorAll('.page_popup_btn').forEach(button => {
      button.addEventListener('click', () => {
        const popupSelector = button.getAttribute('data-popup');
        const popup = document.querySelector(popupSelector);
        if (popup) popup.classList.add('show');
      });
    });

    document.querySelectorAll('.page_content_popup .close_popup_btn').forEach(button => {
      button.addEventListener('click', () => {
        const popup = button.closest('.page_content_popup');
        popup.classList.remove('show');
      });
    });


}

